// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FOD_CQJQ1gZXtn8xtoWl{flex-direction:column;gap:16px;margin-top:4px;display:flex}.nEh8DIuEhK0vSmRBc2iB{gap:4px;display:grid}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `FOD_CQJQ1gZXtn8xtoWl`,
	"inputWrap": `nEh8DIuEhK0vSmRBc2iB`
};
export default ___CSS_LOADER_EXPORT___;
